export const HALF_DIVISOR = 2
export const ANIMATION_DURATION = 1300
export const ROTATION_DEGREES = '132deg'
